import { Component } from '@builder.io/sdk';

import colors from '../../design-system/colors';
import { createFontConfigInputs } from './fontConfig';

export const config: Component = {
    name: 'Text SB',
    inputs: [
        {
            name: 'htmlElement',
            type: 'string',
            friendlyName: 'HTML Element',
            defaultValue: 'span',
            enum: ['span', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
            helperText: 'Choose which HTML element to render',
        },
        {
            name: 'text',
            type: 'string',
            defaultValue: 'Text goes here',
            required: true,
        },
        ...createFontConfigInputs(),
        {
            name: 'fontColor',
            type: 'color',
            defaultValue: '#000000',
            helperText: 'Text color',
        },
    ],
};
